<template>
<ErrorBase
  errorCode="403"
  title="Forbidden"
  subTitle="You do not have the required permissions to view this page."
>
<div class="help">
      <h3>Here are some helpful links instead:</h3> 
      <ul class="links">
        <li>
          <a target="_blank" href="/app/merchant/#/dashboard">
          Dashboard
        </a>
        </li> 
        <li>
          <a target="_blank" href="https://support.shipbob.com">
          ShipBob Help Center
        </a>
        </li>
      </ul>
</div>
</ErrorBase>
</template>
<script>
export default {
  name: 'Forbidden'
}
</script>
<style scoped lang="scss">
</style>